import { render, staticRenderFns } from "./MedalImage.vue?vue&type=template&id=2b960960&"
import script from "./MedalImage.vue?vue&type=script&lang=js&"
export * from "./MedalImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports